export default __webpack_public_path__ + "static/media/silent_generation.cd6fab57.svg";